/*
 *  BRAINTREE
 */
function appendHiddenInput(name, value, append){
	var input = document.createElement('input');
	input.setAttribute('type', 'hidden');
	input.setAttribute('name', name);
	input.setAttribute('value', value);
	append.append(input);
}

BraintreeForm = {
	paymentForm: null,
	$paymentForm: null,
	clientToken: null,
	instance: {
		hostedFields: null,
		paypal: null
	},
	options: {
		client: null,
		styles: {
			'input': {
				'font-size': '15px',
				'color': '#000'
			},
			'input.invalid': {
				'color': '#ee3c3c'
			}
		},
		fields: {
			'number': {
				'selector': '#card-number'
			},
			'cvv': {
				'selector': '#cvv'
			},
			'expirationDate': {
				'selector': '#expiration-date'
			}
		}
	},

	initialize: function(formSelector, submitName){
		this.paymentForm = document.querySelector(formSelector);
		this.$paymentForm = $(formSelector);
		this.clientToken = $('#client-token').val();
		this.submitName = submitName;

		if(!this.paymentForm || !this.$paymentForm.length || this.clientToken === ''){
			console.error('missing payment form or client token');
			return;
		}

		$.ajaxSetup({cache: true});
		$.when(
			$.getScript('https://js.braintreegateway.com/web/3.42.0/js/client.min.js'),
			$.getScript('https://js.braintreegateway.com/web/3.42.0/js/hosted-fields.min.js'),
			$.getScript('https://js.braintreegateway.com/web/3.42.0/js/paypal.min.js'),
			$.Deferred(function(deferred){
				$(deferred.resolve);
			})
		).done(function(){
			BraintreeForm.createClient();
		});
	},

	createClient: function(){
		braintree.client.create({
			authorization: BraintreeForm.clientToken
		}, function(clientErr, clientInstance){
			if(clientErr){
				console.error(clientErr);
				return;
			}

			BraintreeForm.options.client = clientInstance;
			BraintreeForm.createHostedFields();
			BraintreeForm.createPayPal();
		});
	},

	createHostedFields: function(){
		braintree.hostedFields.create(BraintreeForm.options, function(hostedFieldsErr, hostedFieldsInstance){
			if(hostedFieldsErr){
				$('#credit-card-error').removeClass('invisible');
				$('#blanket').remove();
				console.error(hostedFieldsErr);
				return;
			}

			BraintreeForm.instance.hostedFields = hostedFieldsInstance;

			hostedFieldsInstance.on('validityChange', BraintreeForm.showError);

			// Submit the form when user presses enter inside hosted field
			hostedFieldsInstance.on('inputSubmitRequest', BraintreeForm.handleSubmit);

			BraintreeForm.paymentForm.addEventListener('submit', BraintreeForm.handleSubmit, false);
		});
	},

	createPayPal: function(){
		braintree.paypal.create({
			client: BraintreeForm.options.client
		}, function(paypalErr, paypalInstance){
			if(paypalErr){
				console.error(paypalErr);
				return;
			}

			BraintreeForm.instance.paypal = paypalInstance;

			// Handle submit
			$('#submit-method-paypal input').on('click', BraintreeForm.handleSubmit);
		});
	},

	showError: function(e){
		var field = e.fields[e.emittedBy];

		if(!field.isValid && !field.isPotentiallyValid){
			$('label[for=' + field.container.id + ']').addClass('error');
		}
		else{
			$('label[for=' + field.container.id + ']').removeClass('error');
		}
	},

	handleSubmit: function(e){
		if(e.type !== undefined){
			e.preventDefault();
		}

		showProgressAnimation(false);

		var paymentMethod = $('input[name=payment-method]:checked', 'form').val();
		var $savePayment = $('#save-payment');
		var paypalData = {};

		if($('#edit-billing').data('dosubmit') === true){
			appendHiddenInput('SUBMIT_ADDRESS_INFORMATION', 'Continue', BraintreeForm.$paymentForm);
			BraintreeForm.paymentForm.submit();
		}
		else if(paymentMethod == 'checkout_cardstored'){
			appendHiddenInput(BraintreeForm.submitName, 'Continue', BraintreeForm.$paymentForm);
			BraintreeForm.paymentForm.submit();
		}
		else if(paymentMethod == 'checkout_express'){
			if($savePayment.prop('checked') || ($savePayment.attr('type') === 'hidden' && $savePayment.val() === 'true')){
				paypalData = {
					flow: 'vault'
				};
			}
			else{
				paypalData = {
					flow: 'checkout',
					amount: (order_total).toFixed(2),
					currency: 'USD'
				};
			}

			BraintreeForm.instance.paypal.tokenize(paypalData, function(tokenizeErr, payload){
				if(tokenizeErr || typeof payload.nonce === undefined){
					$('#blanket').remove();
					console.error(tokenizeErr);
					return;
				}

				$('#payment-method-nonce').val(payload.nonce);
				appendHiddenInput(BraintreeForm.submitName, 'Continue', BraintreeForm.$paymentForm);
				BraintreeForm.paymentForm.submit();
			});
		}
		else{
			BraintreeForm.instance.hostedFields.tokenize(function(tokenizeErr, payload){
				if(tokenizeErr || typeof payload.nonce === undefined){
					$('#credit-card-error').removeClass('invisible');
					$('#blanket').remove();
					// see https://braintree.github.io/braintree-web/3.29.0/HostedFields.html#tokenize
					console.error(tokenizeErr);

					// Reset hosted fields in case of error
					BraintreeForm.instance.hostedFields.teardown(function(){
						BraintreeForm.createHostedFields();
						BraintreeForm.paymentForm.removeEventListener('submit', BraintreeForm.handleSubmit, false);
					});
					document.getElementById("hostedfields").innerHTML = tokenizeErr;
					document.getElementById('hostedfields').style.display = 'inline';
					document.getElementById('hostedfields').style.color = 'red';
					return;
				}

				$('#payment-method-nonce').val(payload.nonce);
				appendHiddenInput(BraintreeForm.submitName, 'Continue', BraintreeForm.$paymentForm);
				BraintreeForm.paymentForm.submit();
			});
		}

	}
};

(function($){
	// Initialize the Braintree form
	if($('#billing-payment').length){
		BraintreeForm.initialize('#billing-payment', 'SUBMIT_BILLING_PAYMENT');
	}

	if($('#store-payment').length){
		BraintreeForm.initialize('#store-payment', 'SUBMIT_STORE_PAYMENT');
	}
})(jQuery);
